import { jrCurrency } from "../currency_format";

export const CurrencyMixin = {
    props: {
        currencyCode: {
            type: String,
            default: null
        }
    },

    methods: {
        localCurrency(value) {
            return jrCurrency(value, this.localCurrencyCode);
        },
        currency(value) {
            return jrCurrency(value, this.currencyCode || "USD");
        },
        usd(value) {
            return jrCurrency(value, "USD");
        },
        trimmedCurrency(value, code) {
            return jrCurrency(value, code || "USD").replace(/[.,]00$/, "");
        },
        valueRange(minValue, maxValue, code) {
            let html = this.trimmedCurrency(minValue, code);
            if (minValue !== maxValue) {
                if (code === "USD") {
                    html += " - " + this.trimmedCurrency(maxValue, code);
                } else {
                    html = "from " + html;
                }
            }
            return html;
        },
        regularPriceLabel(pricing) {
            let html = "";
            if (pricing.sale_type === "full_sale") {
                html += "Was ";
            }
            html += this.valueRange(pricing.min_price, pricing.max_price, "USD");
            return html;
        },
        salePriceLabel(pricing) {
            let html = "";
            if (pricing.sale_type !== "no_sale") {
                if (pricing.sale_type === "partial_sale") {
                    html += "Select colors ";
                } else if (pricing.sale_type === "full_sale") {
                    html += "Now ";
                }
                html += this.valueRange(
                    pricing.min_discount_price,
                    pricing.max_discount_price,
                    "USD"
                );
            }
            return html;
        }
    },

    computed: {
        localCurrencyCode() {
            return window.jrConfig.currency || "USD";
        },
        isNonUSD() {
            return this.localCurrencyCode !== "USD";
        }
    }
};
